export class ValidationTypes {
  static required = 'required';
  static requiredTrue = 'requiredTrue';
  static minimum = 'min';
  static notEqualTo = 'notEqualTo';
  static equalTo = 'equalTo';
  static maximum = 'max';
  static maximumLength = 'maxLength';
  static minimumLength = 'minLength';
  static exactLength = 'length';
  static pattern = 'pattern';
  static uniqueInvoiceNumber = 'uniqueInvoiceNumber';
  static dateRange = 'dateRange';
  static olderThan18 = 'olderThan18';
}
